module.exports = __webpack_public_path__ + "img/MDI-information.eff058c7.svg";